/**
 * Dialog with input
 * Show text title,catpion and some buttons
 */
import React from 'react';
import PropTypes from 'prop-types';
import ModalDialog from './ModalDialog';
import { Form } from 'react-bootstrap';

const ModalInput = ({ title, caption, lines, buttons, show, setShow }) => {
  // State
  const [text, setText] = React.useState('');

  return (
    <ModalDialog
      title={title}
      modalShow={show}
      setModalShow={setShow}
      data={{ input: text }}
      buttons={buttons}
    >
      <>
        {caption ? <h5>{caption}</h5> : null}
        <Form.Control
          as={lines > 1 ? 'textarea' : 'input'}
          rows={lines}
          value={text}
          onChange={({ target }) => setText(target.value)}
        />
      </>
    </ModalDialog>
  );
};

ModalInput.propTypes = {
  title: PropTypes.string,
  caption: PropTypes.string,
  lines: PropTypes.number,
  buttons: PropTypes.array,
  show: PropTypes.bool,
  setShow: PropTypes.func
};

export default ModalInput;
